/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2019, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { schema } from 'normalizr';

import { isActionSkill } from '@ibm-watson/shared/modules/actions/util/skill';

export const workspaceSchema = new schema.Entity(
  'workspaces',
  {},
  {
    idAttribute: workspace => workspace.workspace_id
  }
);

export const defaultWorkspaceSchema = new schema.Entity(
  'default_content',
  {},
  {
    idAttribute: workspace => {
      let id = `dialog-${workspace.language}`;
      if (workspace && workspace.actions) {
        id = `action-${workspace.language}`;
      }
      return id;
    }
  }
);

export const sampleWorkspaceSchema = new schema.Entity(
  'sample_content',
  {},
  {
    idAttribute: skill => {
      let id = `dialog-${skill.language}`;
      if (isActionSkill(skill)) {
        id = `actions-${skill.language}`;
      }
      return id;
    }
  }
);
